import React, { useId } from 'react';
import './styles.scoped.css';

const FormDateField = ({
  label,
  required = false,
  error,
  errorMessage,
  disabled = false,
  range = false,
  valueFrom,
  valueTo,
  onChangeFrom,
  onChangeTo,
  className = '',
  style = {},
  ...rest
}) => {
  const fieldId = useId();
  const fromId = `${fieldId}-from`;
  const toId = `${fieldId}-to`;
  const errorId = `${fieldId}-error`;

  return (
    <div className={`form-date-field ${className}`} style={style}>
      {label && (
        <label htmlFor={range ? fromId : fieldId} className={`label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <div className="input-wrapper">
        {range ? (
          <div className="date-range-row">
            <input
              id={fromId}
              className={`input ${error ? 'input-error' : ''}`}
              type="date"
              disabled={disabled}
              value={valueFrom}
              onChange={onChangeFrom}
              aria-label={`${label} from`}
              aria-required={required || undefined}
              aria-invalid={!!error || undefined}
              aria-describedby={error ? errorId : undefined}
            />
            <span className="range-separator">to</span>
            <input
              id={toId}
              className={`input ${error ? 'input-error' : ''}`}
              type="date"
              disabled={disabled}
              value={valueTo}
              onChange={onChangeTo}
              aria-label={`${label} to`}
              aria-required={required || undefined}
              aria-invalid={!!error || undefined}
              aria-describedby={error ? errorId : undefined}
            />
          </div>
        ) : (
          <input
            id={fieldId}
            className={`input ${error ? 'input-error' : ''}`}
            type="date"
            disabled={disabled}
            aria-required={required || undefined}
            aria-invalid={!!error || undefined}
            aria-describedby={error ? errorId : undefined}
            {...rest}
          />
        )}
        {error && errorMessage && (
          <span id={errorId} className="error-message">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default FormDateField;
